module.exports = __webpack_public_path__ + "img/pin_gray.b2b27286.svg";